
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import {
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const DynamicVideoCarousel = ({
  videos,
  heading,
  showNavigation = true,
}) => {
  const [currentVideoIndex, setCurrentVideoIndex] =
    useState(0);

  const nextVideo = () => {
    setCurrentVideoIndex(
      (prevIndex) =>
        (prevIndex + 1) % videos.length
    );
  };

  const prevVideo = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0
        ? videos.length - 1
        : prevIndex - 1
    );
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => nextVideo(),
    onSwipedRight: () => prevVideo(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <div className="w-full relative">
      {/* OPTIONAL HEADING */}
      {heading && (
        <div className="text-center mb-12">
          <h2
            className="
              text-[clamp(38px,5vw,64px)]
              leading-[1.02]
              tracking-[-0.05em]
              text-secondary
            "
            style={{
              fontWeight: 400,
            }}
          >
            {heading}
          </h2>
        </div>
      )}

      {/* MAIN VIDEO WRAPPER */}
      <div
        {...swipeHandlers}
        className="
          relative
          w-full
          max-w-[980px]
          mx-auto
        "
      >
        {/* GLOW */}
        <div className="absolute -inset-6 bg-[#F28C28]/10 blur-[80px] rounded-[50px]" />

        {/* VIDEO CARD */}
        <div
          className="
            relative
            overflow-hidden
            rounded-[38px]
            bg-white/60
            backdrop-blur-2xl
            border
            border-white/50
            shadow-[0_30px_80px_rgba(20,10,0,.10)]
            p-3
            md:p-5
          "
        >
          {/* INNER OVERLAY */}
          <div
            className="
              absolute
              inset-0
              bg-gradient-to-br
              from-white/30
              to-transparent
              pointer-events-none
              rounded-[38px]
            "
          />

          {/* VIDEO CONTAINER */}
          <div
            className="
              relative
              aspect-video
              overflow-hidden
              rounded-[28px]
              bg-black
            "
          >
            {/* VIDEO */}
            <iframe
              key={currentVideoIndex}
              className="
                absolute
                inset-0
                w-full
                h-full
              "
              src={`${videos[currentVideoIndex]}?autoplay=1&mute=1&loop=1&playlist=${
                videos[currentVideoIndex]
                  .split("/")
                  .pop()
              }&modestbranding=1&rel=0`}
              title={`Video ${
                currentVideoIndex + 1
              }`}
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />

            {/* DARK CINEMATIC OVERLAY */}
            <div
              className="
                absolute
                inset-0
                bg-gradient-to-t
                from-black/20
                via-transparent
                to-transparent
                pointer-events-none
              "
            />

            {/* NAVIGATION */}
            {showNavigation &&
              videos.length > 1 && (
                <>
                  {/* LEFT */}
                  <button
                    onClick={prevVideo}
                    className="
                      absolute
                      left-4
                      top-1/2
                      -translate-y-1/2
                      w-12
                      h-12
                      rounded-full
                      bg-white/10
                      backdrop-blur-xl
                      border
                      border-white/10
                      text-white
                      flex
                      items-center
                      justify-center
                      transition-all
                      duration-300
                      hover:bg-white/20
                      hover:scale-105
                    "
                  >
                    <ChevronLeft size={20} />
                  </button>

                  {/* RIGHT */}
                  <button
                    onClick={nextVideo}
                    className="
                      absolute
                      right-4
                      top-1/2
                      -translate-y-1/2
                      w-12
                      h-12
                      rounded-full
                      bg-white/10
                      backdrop-blur-xl
                      border
                      border-white/10
                      text-white
                      flex
                      items-center
                      justify-center
                      transition-all
                      duration-300
                      hover:bg-white/20
                      hover:scale-105
                    "
                  >
                    <ChevronRight size={20} />
                  </button>
                </>
              )}
          </div>

          {/* FOOTER */}
          <div
            className="
              flex
              items-center
              justify-between
              mt-5
              px-2
            "
          >
            {/* COUNT */}
            <div
              className="
                text-[#6B574A]
                text-sm
                font-medium
              "
            >
              {currentVideoIndex + 1} /{" "}
              {videos.length}
            </div>

            {/* DOTS */}
            <div className="flex items-center gap-2">
              {videos.map((_, index) => (
                <button
                  key={index}
                  onClick={() =>
                    setCurrentVideoIndex(index)
                  }
                  className={`
                    transition-all
                    duration-300
                    rounded-full

                    ${
                      currentVideoIndex === index
                        ? "w-8 h-2 bg-[#F28C28]"
                        : "w-2 h-2 bg-[#D8C5B6]"
                    }
                  `}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicVideoCarousel;
